import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * This component renders robots.txt content as plain text
 * Uses a pre tag to display content without any styling
 */
const RobotsTxt = () => {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchRobotsTxt = async () => {
      try {
        const response = await axios.get(`${BACKEND_URL}/api/robots.txt`, {
          headers: {
            'Accept': 'text/plain'
          }
        });
        setContent(response.data);
        setError(false);
      } catch (err) {
        console.error("Error fetching robots.txt:", err);
        // Fallback content
        setContent(`User-agent: *
Allow: /
Disallow: /admin/

Sitemap: https://kokanhomestays.in/sitemap.xml`);
        setError(false);
      } finally {
        setLoading(false);
      }
    };

    fetchRobotsTxt();
  }, []);

  // Remove all styles and render as plain text
  useEffect(() => {
    // Hide all other elements and show only content
    document.body.style.margin = '0';
    document.body.style.padding = '8px';
    document.body.style.fontFamily = 'monospace';
    document.body.style.fontSize = '14px';
    document.body.style.backgroundColor = 'white';
    document.body.style.color = 'black';
    
    // Remove any injected styles
    const styleSheets = document.querySelectorAll('link[rel="stylesheet"]');
    styleSheets.forEach(sheet => sheet.remove());
    
    // Set content type meta tag
    let meta = document.querySelector('meta[http-equiv="Content-Type"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.httpEquiv = 'Content-Type';
      document.head.appendChild(meta);
    }
    meta.content = 'text/plain; charset=utf-8';
    
    // Update title
    document.title = 'robots.txt';
    
    return () => {
      // Cleanup not needed as page will reload on navigation
    };
  }, []);

  if (loading) {
    return null;
  }

  // Render as plain text
  return (
    <pre style={{
      margin: 0,
      padding: 0,
      fontFamily: 'monospace',
      fontSize: '14px',
      whiteSpace: 'pre-wrap',
      wordWrap: 'break-word'
    }}>
      {content}
    </pre>
  );
};

export default RobotsTxt;
